import { faComment, faInfoCircle, faQuestionCircle, faExclamationTriangle, faGiftCard, faRetweet, faUser, faCheckSquare, faBroom, IconDefinition } from '@fortawesome/pro-light-svg-icons'; // 'fal' (Light version)
import { faExclamationCircle as faExclamationCircleSolid } from '@fortawesome/free-solid-svg-icons'; // 'fas' (Solid version)

import { MessageTypes } from "../models";

export const MessageTypeIcons = [
	{ type: MessageTypes.Note, icon: faComment },
	{ type: MessageTypes.Info, icon: faInfoCircle },
	{ type: MessageTypes.Question, icon: faQuestionCircle },
	{ type: MessageTypes.Warning, icon: faExclamationTriangle },
	{ type: MessageTypes.Problem, icon: faExclamationCircleSolid }, // 'fas' solid version
	{ type: MessageTypes.Coupon, icon: faGiftCard, adminOnly: true },
	{ type: MessageTypes.StatusChange, icon: faRetweet, adminOnly: true },
	{ type: MessageTypes.CaseWorker, icon: faUser, adminOnly: true },
	{ type: MessageTypes.CompletionDate, icon: faCheckSquare, adminOnly: true },
	{ type: MessageTypes.MessagesReset, icon: faBroom, adminOnly: true }
];

export function getMessageTypeIcon(type: MessageTypes): IconDefinition {
	return this.MessageTypeIcons[type]?.icon || null;
}
